import { cn } from "@omni/utils/styles";

import { DefaultFacetDisplayValue } from "@/components/Search/SearchResults/StateComponents/Facets/Facet/components/DefaultFacet/defaultFacet.container";
import { DefaultFacetValueComponent } from "@/components/Search/SearchResults/StateComponents/Facets/Facet/components/DefaultFacet/defaultFacetValue.component";

type DefaultFacetComponentProps = {
    values: Array<DefaultFacetDisplayValue>;
    showCount: boolean;
};

const DefaultFacetComponent = ({
    values,
    showCount
}: DefaultFacetComponentProps) => (
    <ul className={cn("tw:pl-0 tw:mb-0 ")}>
        {values.map((value) => (
            <DefaultFacetValueComponent
                key={`${value.label}-${value.refined}`}
                value={value}
                showCount={showCount}
            />
        ))}
    </ul>
);

export { DefaultFacetComponent };
